/**
 * Determines if the current device is iPhone or iPad and browser is Safari.
 */
export const isIOSSafari = () => {
  if (typeof navigator === "undefined" || !navigator.userAgent) {
    return false;
  }

  const ua = navigator.userAgent;
  const isIPhone = /iPhone/.test(ua);

  // iPad detection is a bit tricky since iPads can also report as Macintosh in some cases.
  // We check for the presence of maxTouchPoints to differentiate iPadOS from macOS.
  // Note: This is a simplified check and may not cover all edge cases.
  const isIPad =
    /iPad/.test(ua) ||
    (ua.includes("Macintosh") &&
      "maxTouchPoints" in navigator &&
      navigator.maxTouchPoints > 2);

  const isSafari =
    ua.includes("Safari") &&
    !ua.includes("CriOS") &&
    !ua.includes("FxiOS") &&
    !ua.includes("OPiOS") &&
    !ua.includes("EdgiOS");

  return (isIPhone || isIPad) && isSafari;
};
